import React from 'react'

import CheckGrid from './CheckGrid'

const renderCheckGrid = config => {
	const { key } = config.field || {}
	return <CheckGrid key={key} config={config} />
}

export default renderCheckGrid